import { A } from '@solidjs/router';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { orgHref } from '../lib/org';
import type { RepoSessionRow } from '../lib/repo-detail';
import { absolute } from '../lib/time';
import { StatusPill, type StatusTone } from './StatusPill';

// One node of the repo Audit timeline (#195/#349) — a `.timeline__item` linking
// into the full /audit/:session_id view (model reasoning + tool calls, streamed
// live). Backed by the dedicated /sessions list, so it carries outcome + model,
// not just a derived activity label. Renders inside an `ol.timeline`.

const OUTCOME_TONE: Record<string, StatusTone> = {
  completed: 'success',
  merged: 'success',
  escalated: 'warning',
  failed: 'danger',
};

export function AuditNode(props: { row: RepoSessionRow }): JSX.Element {
  const tone = (): StatusTone =>
    (props.row.outcome && OUTCOME_TONE[props.row.outcome]) || 'neutral';
  return (
    <li class="timeline__item repo-audit__node" data-outcome={props.row.outcome ?? 'unknown'}>
      <A class="repo-audit__link" href={orgHref(`/audit/${props.row.id}`)}>
        <span class="timeline__dot" aria-hidden="true" />
        <div class="timeline__summary">
          <div>
            <p class="timeline__title">{props.row.title}</p>
            <p class="timeline__meta">
              <code>{props.row.id}</code> ·{' '}
              <span title={t('repo_detail.audit_model_label')}>{props.row.model}</span> ·{' '}
              <time datetime={props.row.started_iso}>{absolute(props.row.started_iso)}</time>
            </p>
          </div>
          <StatusPill tone={tone()}>
            {props.row.outcome ?? t('repo_detail.audit_running')}
          </StatusPill>
        </div>
      </A>
    </li>
  );
}
